import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.066 8.002a9 9 0 1 0 .934 3.998h-13","key":"svg-0"}],["path",{"d":"M12 8l-4 4l4 4","key":"svg-1"}]]

/**
 * IconCircleOpenArrowLeft
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLW9wZW4tYXJyb3ctbGVmdCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMjAuMDY2IDguMDAyYTkgOSAwIDEgMCAuOTM0IDMuOTk4aC0xMyIgLz4KICA8cGF0aCBkPSJNMTIgOGwtNCA0bDQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/circle-open-arrow-left
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleOpenArrowLeft = createReactComponent('outline', 'circle-open-arrow-left', 'CircleOpenArrowLeft', __iconNode);

export default IconCircleOpenArrowLeft;